var map = {
	"./courseArrange.svg": "ffdc",
	"./courseCharts.svg": "045f",
	"./courseFile.svg": "7a1e",
	"./courseList.svg": "33a8",
	"./courseMeta.svg": "ac35",
	"./index.svg": "abb8",
	"./judges.svg": "77b7",
	"./zsktsgl.svg": "0b9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";